<template>
  <el-dialog class="dialog-add-choose-collect" :class="{ 'view-dialog': pageType == 'detail' }" :title="title"
    :visible.sync="dialogVisible" :width="pageType == 'detail' ? '65%' : '75%'" @close="onCancel">
    <div class="table-content">
      <el-form ref="addForm" :model="addForm" label-width="120px" :rules="rules">
        <el-row>
          <el-col v-if="pageType == 'detail'" :span="8">
            <el-row style="margin-right: 16px">
              <el-form-item class="avatar-uploader-form collect-form">
                <viewer :images="imgArr" @inited="inited" rebuild :options="{ title: false }">
                  <img v-show="false" v-for="(item, index) in imgArr" :src="item" :key="index" />
                </viewer>
                <img v-if="imgUrl" :src="imgUrl || ''" @click="handlePreview" :data-maxUrl="imgUrl"
                  style="width: 100%; height: 100%; object-fit: contain" :onerror="defaultImg" />
                <span class="no-img" v-else>暂无藏品图片</span>
              </el-form-item>

              <div class="swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(item, index) in addForm.collectImages" @click="setImg(item)"
                    style="height: 120px" :key="index">
                    <img :src="item.attPath" alt="" />
                  </div>
                </div>
                <div class="swiper-button-prev swiper-button-white"></div>
                <div class="swiper-button-next swiper-button-black"></div>
              </div>

              <div class="hd-wrapper">
                <div class="item mr-20" @click="handleHD" v-if="addForm.attachmentId">
                  <i style="color: #018f78" class="el-icon-search mr-5"></i>
                  查看大图
                </div>

                <div class="item" @click="handleThreeDimensionalInfo" v-if="addForm.threeDimensionalInfo">
                  <i style="color: #018f78" class="el-icon-search mr-5"></i>
                  查看三维模型
                </div>
              </div>
            </el-row>
          </el-col>
          <el-col :span="pageType == 'detail' ? 16 : 24" :class="{ 'bg-content': pageType === 'detail' }">
            <el-col :span="pageType != 'detail' ? 12 : 24">
              <el-form-item label="藏品名称 :" prop="collectName">
                <el-input v-model="addForm.collectName" :disabled="pageType === 'detail'"
                  :placeholder="pageType == 'detail' ? '' : '请输入'"></el-input>
              </el-form-item>

              <el-form-item label="文物类别 :" prop="collectType">
                <el-input v-model="addForm.collectType" :disabled="pageType === 'detail'"
                  :placeholder="pageType == 'detail' ? '' : '请输入'"></el-input>
              </el-form-item>

              <el-form-item label="文物级别 :" prop="collectLevel">
                <el-input v-model="addForm.collectLevel" :disabled="pageType === 'detail'"
                  :placeholder="pageType == 'detail' ? '' : '请输入'"></el-input>
              </el-form-item>

              <el-form-item label="年代 :" prop="collectYear">
                <el-input v-model="addForm.collectYear" :disabled="pageType === 'detail'"
                  :placeholder="pageType == 'detail' ? '' : '请输入'"></el-input>
              </el-form-item>

              <el-form-item label="尺寸 :" prop="detailSize">
                <el-input v-model="addForm.detailSize" :disabled="pageType === 'detail'"
                  :placeholder="pageType == 'detail' ? '' : '请输入'"></el-input>
              </el-form-item>

              <el-form-item label="质地 :" prop="collectTexture">
                <el-input v-model="addForm.collectTexture" :disabled="pageType === 'detail'"
                  :placeholder="pageType == 'detail' ? '' : '请输入'"></el-input>
              </el-form-item>

              <el-form-item v-if="pageType === 'detail'" label="藏品描述 :" prop="collectSynopsis">
                <div class="trans" v-html="addForm.collectSynopsis"></div>
              </el-form-item>

              <el-form-item v-if="pageType != 'detail'" label="藏品图片：" prop="pictureIds">
                <el-upload ref="upload1" :file-list="fileList1" action="/singleMuseum/attach/upload"
                  list-type="picture-card" :disabled="pageType == 'detail'" accept="image/*" :data="configData"
                  :on-remove="(response, file, fileList) => {
                    handleUnitPicRemove(response, file, '1')
                  }
                    " :on-success="(response, file, fileList) => {
                      handleUnitPicSuccess(response, file, fileList, '1')
                    }
                      " :before-upload="beforeUnitPicUpload" multiple>
                  <div class="img-uploader">
                    <i class="el-icon-plus"></i>
                    <span>上传藏品图片</span>
                  </div>
                  <div class="h-100" slot="file" slot-scope="{ file }">
                    <img :src="file.url" mode="aspectFit" alt="" class="el-upload-list__item-thumbnail"
                      :ref="'file_' + file.uid" />
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-preview" @click="rotateImg(file, '2')"><i
                          class="el-icon-refresh-left"></i></span>
                      <span class="el-upload-list__item-delete" @click="handleRemove(file, fileList1, '1')"><i
                          class="el-icon-delete"></i></span>
                      <span class="el-upload-list__item-rotate" @click="rotateImg(file, '1')"><i
                          class="el-icon-refresh-right"></i></span>
                    </span>
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item v-if="pageType != 'detail'" label="高清图片：">
                <el-upload ref="upload2" :file-list="fileList2" action="/singleMuseum/attach/upload"
                  list-type="picture-card" :disabled="pageType == 'detail'" accept="image/*" :data="configData"
                  :on-remove="(response, file, fileList) => {
                    handleUnitPicRemove(response, file, '2')
                  }
                    " :on-success="(response, file, fileList) => {
                      handleUnitPicSuccess(response, file, fileList, '2')
                    }
                      " :before-upload="beforeUnitPicUpload" multiple>
                  <div class="img-uploader">
                    <i class="el-icon-plus"></i>
                    <span>上传高清图片</span>
                  </div>

                  <div class="h-100" slot="file" slot-scope="{ file }">
                    <img :src="file.url" mode="aspectFit" alt="" class="el-upload-list__item-thumbnail"
                      :ref="'file_' + file.uid" />
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-preview" @click="rotateImg(file, '2')"><i
                          class="el-icon-refresh-left"></i></span>
                      <span class="el-upload-list__item-delete" @click="handleRemove(file, fileList2, '2')"><i
                          class="el-icon-delete"></i></span>
                      <span class="el-upload-list__item-rotate" @click="rotateImg(file, '1')"><i
                          class="el-icon-refresh-right"></i></span>
                    </span>
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>

            <el-col v-if="pageType != 'detail'" :span="12">
              <el-form-item label="藏品描述 :" prop="collectSynopsis">
                <cmp-ckeditor ref="myCkeditor" :readOnly="pageType == 'detail'" :defaultMsg="addForm.collectSynopsis"
                  :id="`ue1`" :height="150"></cmp-ckeditor>
              </el-form-item>

              <el-form-item v-if="collectionType == 2" label="三维模型：" prop="threeDimensionalInfo">
                <el-upload class="el-upload el-upload--picture-card" style="width: 146px; height: 146px"
                  action="/singleMuseum/collection/upload3d" :disabled="pageType === 'detail'" accept=".zip"
                  :show-file-list="false" :on-success="handle3DSuccess" :before-upload="before3DUpload">
                  <div class="img-uploader">
                    <i class="el-icon-plus"></i>
                    <div class="el-upload__text">上传三维模型</div>
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
      <div class="img-wrap" v-viewer ref="viewer" v-show="showHD">
        <img v-for="(item, index) in addForm.highImages" :src="item.attPath" :key="index" style="width: 100%" />
        <!-- <div ref="nodata" style="text-align: center;margin-top:100px;" v-if="!imageScreen.length">暂无数据</div> -->
      </div>

      <div class="img-wrap" v-viewer ref="viewer1" v-show="showCard">
        <img v-for="(item, index) in addForm.cardImages" :src="item.attPath" :key="index" style="width: 100%" />
        <!-- <div ref="nodata" style="text-align: center;margin-top:100px;" v-if="!imageScreen.length">暂无数据</div> -->
      </div>
      <div class="dialog-footer tr mt-30" v-if="pageType !== 'detail'">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import Sortable from 'sortablejs'
import cmpCkeditor from '@cmp/editor/ckeditor'

export default {
  computed: {
    ...mapGetters(['imageTypes'])
  },
  props: ['ext2'],
  components: { cmpCkeditor },
  data() {
    return {
      defaultImg: this.$store.state.app.defaultImg,
      showHD: false,
      showCard: false,

      swiperOptionTop: {
        autoplay: true,
        slidesPerView: '3',
        spaceBetween: 20,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          disabledClass: 'my-button-disabled'
        },
        on: {
          slideChangeTransitionEnd: function () {
            // 监听slide切换结束后
            let boxs = Math.ceil(this.slides.length / 3) // 确定有几屏
            let swiper2 = document.getElementsByClassName('box')[0]
            let nextB = swiper2.getElementsByClassName('swiper-button-next')
            let prevB = swiper2.getElementsByClassName('swiper-button-prev')
            nextB[0].setAttribute('class', 'swiper-button-next')
            prevB[0].setAttribute('class', 'swiper-button-prev')
            if (this.activeIndex === boxs - 1) {
              // 切换结束后，如果为最后一屏next按钮置灰
              nextB[0].setAttribute(
                'class',
                'swiper-button-next my-button-disabled'
              )
            }
            if (this.activeIndex === 0) {
              // 切换结束后，如果为第一屏next按钮置灰
              prevB[0].setAttribute(
                'class',
                'swiper-button-prev my-button-disabled'
              )
            }
          },
          init: function () {
            //监听swiper初始化时，对左右按钮样式进行处理
            let boxs = Math.ceil(this.slides.length / 3)
            let swiper2 = document.getElementsByClassName('box')[0]
            let nextB = swiper2.getElementsByClassName('swiper-button-next')
            let prevB = swiper2.getElementsByClassName('swiper-button-prev')
            nextB[0].setAttribute('class', 'swiper-button-next')
            // 初始化时，prev按钮是不可点击的，应该置灰
            prevB[0].setAttribute(
              'class',
              'swiper-button-prev my-button-disabled'
            )
            if (boxs === 1) {
              // 如果只有一屏，next按钮也要置灰
              nextB[0].setAttribute(
                'class',
                'swiper-button-next my-button-disabled'
              )
            }
          }
        }
      },
      title: '',
      pageType: '',
      collectId: '',
      dialogVisible: false,
      activeName: 'first',
      addForm: {
        collectId: '',
        signCode: '',
        typeCode: '',
        collectName: '',
        sourceName: '',
        collectYear: '',
        collectDetailYear: '',
        collectType: '',
        collectLevel: '',
        collectTexture: '',
        detailSize: '',
        qualityRange: '',
        detailQuality: '',
        qualityType: '',
        num: '',
        numUnit: '',
        detailNumber: '',
        source: '',
        sourceUnit: '',
        unearthedLocation: '',
        residualCondition: '',
        residualInfo: '',
        saveStatus: '',
        enterCollectRange: '',
        enterCollectYear: '',
        collectSynopsis: '',
        collectInscription: '',
        protectionRecord: '',
        spreadingExperience: '',
        appraisalDate: '',
        appraisalUnit: '',
        appraiser: '',
        appraisalOpinions: '',
        author: '',
        version: '',
        collectPosition: '',
        fileKeep: '',
        pictureIds: '',
        cards: '',
        attachmentId: '',
        threeDimensionalInfo: '',
        ringShotInfo: ''
      },
      collectionType: '',
      collectTypeName: '',
      collectType: [],
      collectLevel: [],
      collectYear: [],
      collectYear1: [],

      collectDisablity: [],
      saveState: [],
      collectionComeFrom: [],
      collectionGroupCode: [],
      collectionCodeType: [],
      massRange: [],
      massUnit: [],
      timeFrame: [],
      collectionCount: [],
      collectTextureType: [],
      configData: {
        tableName: 'collect'
      },
      rules: {
        collectName: [
          { required: true, message: '藏品名称不能为空', trigger: 'blur' }
        ]
      },
      imgArr: [],
      fileList1: [],
      fileList2: [],
      fileList3: [],
      pictureIds: [],
      attachmentId: [],
      cardIds: [],
      fileList: [],
      imgUrl: '',
      imgUrl1: '',
      platOptions: [],
      props: {
        label: 'dictName',
        value: 'dictCode',
        children: 'child',
        checkStrictly: true
      }
    }
  },
  methods: {
    init(operation, id, collectionType) {
      this.pageType = operation
      this.dialogVisible = true
      this.collectionType = collectionType
      this.collectId = id
      this.initSelect(id)
      this.activeName = 'first'

      if (operation == 'add') {
        this.title = '新增藏品信息'
        if (this.collectionType == 2) {
          this.rules['threeDimensionalInfo'] = [
            { required: true, message: '3d藏品不能为空', trigger: 'blur' }
          ]
        }
      } else if (operation == 'edit') {
        this.title = '编辑藏品信息'
        if (this.collectionType == 2) {
          this.rules['threeDimensionalInfo'] = [
            { required: true, message: '3d藏品不能为空', trigger: 'blur' }
          ]
        }
      } else {
        this.title = '查看藏品信息'
        for (let m in this.rules) {
          if (this.rules[m] && this.rules[m].length > 0) {
            this.rules[m][0].required = false
          }
        }
      }
    },

    rotateImg(file, type) {
      if (!file.rotate) {
        this.$set(file, 'rotate', 0)
      }
      if (file.response && file.response.success) {
        if (file.response.result) {
          let attId = file.response.result.attId
          this.$http
            .get('/attach/rotatePicture', {
              id: attId,
              type: type
            })
            .then((res) => {
              if (res.success) {
                if (type == 1 || type == 3) {
                  file.rotate += 90
                }
                if (type == 2 || type == 4) {
                  file.rotate -= 90
                }
                this.$refs[
                  'file_' + file.uid
                ].style.transform = `rotate(${file.rotate}deg)`
                this.$message.success('旋转成功')
              }
            })
        }
      } else {
        var keyValue = file.url.split('=')
        var key = keyValue[0]
        var value = keyValue[1]

        if (value) {
          let keyValue1 = value.split('&'),
            attId = keyValue1[0]
          this.$http
            .get('/attach/rotatePicture', {
              id: attId,
              type: type
            })
            .then((res) => {
              if (res.success) {
                if (type == 1) {
                  file.rotate += 90
                } else {
                  file.rotate -= 90
                }
                this.$refs[
                  'file_' + file.uid
                ].style.transform = `rotate(${file.rotate}deg)`
                this.$message.success('旋转成功')
              }
            })
        }
      }
    },

    handleRemove(file, fileList, type) {
      let newList = fileList.filter((item) => {
        return item.uid != file.uid
      })

      if (type == 1) {
        this.pictureIds = []
        this.fileList1 = newList
      } else if (type == 2) {
        this.attachmentId = []
        this.fileList2 = newList
      } else {
        this.cardIds = []
        this.fileList3 = newList
      }
      if (newList && newList.length > 0) {
        newList.map((item) => {
          if (item.response && item.response.result) {
            if (type == 1) {
              this.pictureIds.push(item.response.result.attId)
            } else if (type == 2) {
              this.attachmentId.push(item.response.result.attId)
            } else if (type == 3) {
              this.cardIds.push(item.response.result.attId)
            }
          } else {
            // 修改状态
            if (item.url) {
              let arr = item.url.split('&'),
                arr1 = arr[0].split('=')

              if (type == 1) {
                this.pictureIds.push(arr1[1])
              } else if (type == 2) {
                this.attachmentId.push(arr1[1])
              } else if (type == 3) {
                this.cardIds.push(arr1[1])
              }
            }
          }
        })
      }
    },

    handleHD() {
      // 直接显示图片
      const viewer = this.$refs['viewer'].$viewer
      viewer.show()
    },

    handleCard() {
      // 直接显示图片
      const viewer = this.$refs['viewer1'].$viewer
      viewer.update().view(0)
      viewer.show()
    },

    handleThreeDimensionalInfo() {
      window.open(this.addForm.threeDimensionalInfo, '_blank')
    },

    getSelect(value, type) {
      this.$http
        .post('/collectDict/getDictListByPid', { pid: value })
        .then((res) => {
          if (res.success) {
            this.collectYear1 = res.result
          }
        })
    },

    handleItemChange(value) {
      // 动态/异步加载分类数据
      let parentId = ''
      this.addForm.collectDetailYear = ''
      if (value.length === 1) {
        // 如果点击的是一级分类
        parentId = value[0]
        this.platOptions.map((item, index) => {
          if (item.dictCode === parentId && item.child.length === 0) {
            // 当顶级分类的的child为空时才请求数据
            this.$http
              .post('/collectDict/getDictListByPid', { pid: parentId })
              .then((res) => {
                if (res.success) {
                  this.$set(this.platOptions[index], 'child', res.result)
                  item.child.map((innerItem, innerIndex) => {
                    // 二级分类下必须要设置一个空的child数组，不然点击@active-item-change没反应
                    this.$set(item.child[innerIndex], 'child', [])
                  })
                }
              })
          }
        })
      } else {
        // 如果点击的是二级分类，则直接将三级分类绑定到platOptions
        parentId = value[1]
        this.platOptions.map((item, index) => {
          item.child.map((innerItem, innerIndex) => {
            if (
              innerItem.dictCode === parentId &&
              innerItem.child.length === 0
            ) {
              // 当二级分类的的child为空时才请求一次数据
              this.$http
                .post('/collectDict/getDictListByPid', { pid: parentId })
                .then((res) => {
                  if (res.success) {
                    this.$set(item.child[innerIndex], 'child', res.result)
                  }
                })
            }
          })
        })
      }
    },

    // 获取下拉选项的值
    initSelect(id) {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: [
            'collection_year',
            'collection_type',
            'collection_level',
            'collection_texture',
            'degree_disability',
            'save_state',
            'collection_come_from',
            'collection_group_code',
            'contain_collection_count',
            'mass_range',
            'mass_unit',
            'degree_disability',
            'time_frame',
            'collection_code_type'
          ]
        })
        .then((res) => {
          var success = res.success
          if (success) {
            var data = res.result
            this.collectYear = data.collection_year
            this.collectLevel = data.collection_level
            this.collectType = data.collection_type
            this.collectDisablity = data.degree_disability
            this.collectTextureType = data.collection_texture
            this.saveState = data.save_state
            this.collectionComeFrom = data.collection_come_from
            this.collectionGroupCode = data.collection_group_code
            this.massRange = data.mass_range
            this.massUnit = data.mass_unit
            this.timeFrame = data.time_frame
            this.collectionCount = data.contain_collection_count
            this.collectionCodeType = data.collection_code_type

            this.platOptions = this.collectYear
            this.platOptions.map((item, index, array) => {
              // 因为数组和对象更新后不会更新视图，这里必须用$set方法
              this.$set(array[index], 'child', [])
            })

            if (id) {
              this.getDetail(id)
            }
          }
        })
    },

    // 上传团队图片
    beforeUnitPicUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      // if (!isLt2M) {
      //   this.$message({
      //     message: '上传文件大小不能超过 2MB!',
      //     type: 'warning'
      //   })
      //   return
      // }

      if (this.imageTypes.includes(fileType)) {
        return true
      } else {
        this.$message.error('请上传正确的图片类型')
        return
      }
    },

    handleUnitPicSuccess(res, file, fileList, type) {
      if (res.success) {
        this.$message.success('上传成功')
        if (type == 1) {
          this.fileList1 = fileList
          this.pictureIds.push(res.result.attId)
        } else if (type == 2) {
          res.result.url = res.result.attPath
          this.fileList2 = fileList
          this.attachmentId.push(res.result.attId)
        } else if (type == 3) {
          res.result.url = res.result.attPath
          this.fileList3 = fileList
          this.cardIds.push(res.result.attId)
        }
      } else {
        let index = 0
        for (const i in fileList) {
          if (fileList[i] == file) {
            index = i
            break
          }
        }
        //移出当前文件对象
        fileList.splice(index, 1)
        this.$message.error(res.message)
      }
    },

    setImg(obj) {
      this.imgUrl = obj.attPath
    },

    handleUnitPicRemove(file, fileList, type) {
      console.log(fileList)
      if (type == 1) {
        this.pictureIds = []
      } else if (type == 2) {
        this.attachmentId = []
      } else if (type == 3) {
        this.cardIds = []
      }
      if (fileList && fileList.length > 0) {
        fileList.map((item) => {
          if (item.response && item.response.result) {
            if (type == 1) {
              this.pictureIds.push(item.response.result.attId)
            } else if (type == 2) {
              this.attachmentId.push(item.response.result.attId)
            } else if (type == 3) {
              this.cardIds.push(item.response.result.attId)
            }
          } else {
            // 修改状态
            if (item.url) {
              let arr = item.url.split('&'),
                arr1 = arr[0].split('=')

              if (type == 1) {
                this.pictureIds.push(arr1[1])
              } else if (type == 2) {
                this.attachmentId.push(arr1[1])
              } else if (type == 3) {
                this.cardIds.push(arr1[1])
              }
            }
          }
        })
      }
    },

    cascaderList(key1, key2) {
      this.platOptions.map((item, index) => {
        if (item.dictCode === key1) {
          // 当顶级分类的的child为空时才请求数据
          this.$http
            .post('/collectDict/getDictListByPid', { pid: key1 })
            .then((res) => {
              if (res.success) {
                this.$set(this.platOptions[index], 'child', res.result)
                item.child.map((innerItem, innerIndex) => {
                  // 二级分类下必须要设置一个空的child数组，不然点击@active-item-change没反应
                  this.$set(item.child[innerIndex], 'child', [])
                })

                if (key2) {
                  this.platOptions[index].child.map((it, dx) => {
                    if (it.dictCode === key2) {
                      this.$http
                        .post('/collectDict/getDictListByPid', { pid: key2 })
                        .then((res) => {
                          if (res.success) {
                            this.$set(it, 'child', res.result)
                          }
                        })
                    }
                  })
                }
              }
            })
        }
      })
    },

    getDetail(id) {
      this.$http
        .get('/encollection/find', {
          id: id
        })
        .then((res) => {
          if (res.success) {
            this.addForm = res.result

            // 货币 ||印信、符牌 || 流通票证
            if (
              this.addForm.collectType == '862126' ||
              this.addForm.collectType == '862124' ||
              this.addForm.collectType == '862321'
            ) {
              this.$set(this.addForm, 'imgDx', 1)
            }

            // 石器  || 玉器
            else if (
              this.addForm.collectType == '862101' ||
              this.addForm.collectType == '862102'
            ) {
              this.$set(this.addForm, 'imgDx', 2)
            }

            // 铜器  || 雕塑
            else if (
              this.addForm.collectType == '862119' ||
              this.addForm.collectType == '862105'
            ) {
              this.$set(this.addForm, 'imgDx', 3)
            } else if (
              this.addForm.collectType == '862116' ||
              this.addForm.collectType == '862117' ||
              this.addForm.collectType == '862122' ||
              this.addForm.collectType == '862118' ||
              this.addForm.collectType == '862380'
            ) {
              this.$set(this.addForm, 'imgDx', 4)
            } else if (
              this.addForm.collectType == '862104' ||
              this.addForm.collectType == '862109'
            ) {
              this.$set(this.addForm, 'imgDx', 5)
            } else if (
              this.addForm.collectType == '862103' ||
              this.addForm.collectType == '862107'
            ) {
              this.$set(this.addForm, 'imgDx', 6)
            } else {
              this.$set(this.addForm, 'imgDx', 7)
            }

            if (
              res.result.collectImages &&
              res.result.collectImages.length > 0
            ) {
              res.result.collectImages.map((item) => {
                this.imgArr.push(item.attPath)
              })
              this.imgUrl = res.result.collectImages[0].attPath
              this.initSwiper()
            }
            if (
              this.addForm.collectImages &&
              this.addForm.collectImages.length > 0
            ) {
              this.addForm.collectImages.map((item) => {
                this.fileList1.push({
                  name: item.attName,
                  url: item.attPath
                })
              })
              if (this.pageType != 'detail') {
                this.initDragSort()
              }
            }

            if (this.addForm.highImages && this.addForm.highImages.length > 0) {
              this.addForm.highImages.map((item) => {
                this.fileList2.push({
                  name: item.attName,
                  url: item.attPath
                })
              })
              if (this.pageType != 'detail') {
                this.initDragSort1()
              }
            }

            if (this.addForm.cardImages && this.addForm.cardImages.length > 0) {
              this.addForm.cardImages.map((item) => {
                this.fileList3.push({
                  name: item.attName,
                  url: item.attPath
                })
              })
              if (this.pageType != 'detail') {
                this.initDragSort2()
              }
            }

            this.pictureIds =
              (this.addForm.pictureIds && this.addForm.pictureIds.split(',')) ||
              []
            this.attachmentId =
              (this.addForm.attachmentId &&
                this.addForm.attachmentId.split(',')) ||
              []
            this.cardIds =
              (this.addForm.cards && this.addForm.cards.split(',')) || []

            if (res.result.ext1) {
              if (!res.result.ext1.includes('/singleMuseum/attach/getImg')) {
                this.imgUrl1 =
                  '/singleMuseum/attach/getFile?fileId=' + res.result.ext1
              }
            }
          }
        })
    },

    initDragSort() {
      // 支持拖拽排序
      const el = this.$refs.upload1.$el.querySelectorAll('.el-upload-list')[0]
      Sortable.create(el, {
        onEnd: ({ oldIndex, newIndex }) => {
          // 交换位置
          const arr = this.fileList1
          const page = arr[oldIndex]
          let tempIds = []
          arr.splice(oldIndex, 1)
          arr.splice(newIndex, 0, page)
          arr.map((item) => {
            if (item.response && item.response.result) {
              tempIds.push(item.response.result.attId)
            } else {
              if (item.url) {
                let tempUrl = item.url.split('=')
                let attId = tempUrl[1].split('&')[0]
                tempIds.push(attId)
              }
            }
          })

          this.pictureIds = tempIds
          console.log(this.pictureIds)
        }
      })
    },

    initDragSort1() {
      // 支持拖拽排序
      const el = this.$refs.upload2.$el.querySelectorAll('.el-upload-list')[0]
      Sortable.create(el, {
        onEnd: ({ oldIndex, newIndex }) => {
          // 交换位置
          const arr = this.fileList2
          const page = arr[oldIndex]
          let tempIds = []
          arr.splice(oldIndex, 1)
          arr.splice(newIndex, 0, page)
          arr.map((item) => {
            if (item.response && item.response.result) {
              tempIds.push(item.response.result.attId)
            } else {
              if (item.url) {
                let tempUrl = item.url.split('=')
                let attId = tempUrl[1].split('&')[0]
                tempIds.push(attId)
              }
            }
          })

          this.attachmentId = tempIds
        }
      })
    },

    initDragSort2() {
      // 支持拖拽排序
      const el = this.$refs.upload3.$el.querySelectorAll('.el-upload-list')[0]
      Sortable.create(el, {
        onEnd: ({ oldIndex, newIndex }) => {
          // 交换位置
          const arr = this.fileList3
          const page = arr[oldIndex]
          let tempIds = []
          arr.splice(oldIndex, 1)
          arr.splice(newIndex, 0, page)
          arr.map((item) => {
            if (item.response && item.response.result) {
              tempIds.push(item.response.result.attId)
            } else {
              if (item.url) {
                let tempUrl = item.url.split('=')
                let attId = tempUrl[1].split('&')[0]
                tempIds.push(attId)
              }
            }
          })

          this.cardIds = tempIds
        }
      })
    },

    changeCollectType(dx) {
      let arr = this.collectType.filter((item) => {
        return item.dictCode == dx
      })
      this.collectTypeName = arr[0].dictName
    },

    // 上传
    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 2MB!',
          type: 'warning'
        })
        return false
      }

      if (this.imageTypes.includes(fileType)) {
        return true
      } else {
        this.$message.error('请上传正确的图片类型')
        return false
      }
    },

    // handleAvatarSuccess(res, type) {
    //   if (res.success) {
    //     this.$message.success('上传成功')
    //     if (type == 1) {
    //       this.imgUrl = res.result.attPath
    //       this.addForm.ext1 = res.result.attId
    //     } else if (type == 2) {
    //       this.imgUrl1 = res.result.attPath
    //       this.addForm.pictureIds = res.result.attId
    //     }
    //   }
    // },

    before3DUpload(file) {
      let fileType = file.name.split('.')[1]
      if (fileType != 'zip') {
        this.$message({
          message: '请上传压缩文件',
          type: 'warning'
        })
        return
      }
    },

    handleClick() { },

    handle3DSuccess(res) {
      if (res.success) {
        this.$message.success('上传三维模型成功')
        this.addForm.threeDimensionalInfo = res.message
      }
    },

    initSwiper() {
      this.$nextTick(() => {
        var swiper = new Swiper('.swiper-container', {
          slidesPerView: '3',
          spaceBetween: 20,
          prevButton: '.swiper-button-prev',
          nextButton: '.swiper-button-next'
        })
      })
    },

    onSubmit() {
      const self = this
      this.addForm.attachmentId = this.attachmentId.join(',')
      this.addForm.pictureIds = this.pictureIds.join(',')
      this.addForm.cards = this.cardIds.join(',')

      let content = this.$refs.myCkeditor && this.$refs.myCkeditor.getContent() // 调用子组件方法
      if (content) {
        this.addForm.collectSynopsis = content
      }
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          this.$http
            .post('/encollection/save', {
              ...this.addForm,
              type: this.collectionType,
              ext2: this.ext2 || null
            })
            .then((res) => {
              this.$message.success({
                message:
                  this.pageType == 'add' ? '藏品新增成功' : '藏品修改成功',
                duration: 500,
                onClose() {
                  self.onCancel()
                  self.$emit('refresh', {
                    result: res,
                    operation: self.pageType
                  })
                }
              })
            })
        } else {
          return false
        }
      })
    },

    onCancel() {
      this.dialogVisible = false
      this.addForm = {}
      this.imgUrl1 = ''
      this.imgUrl = ''
      this.fileList1 = []
      this.fileList2 = []
      this.fileList3 = []

      this.imgArr = []
      this.pictureIds = []
      this.attachmentId = []
      this.cardIds = []

      this.$refs['addForm'].resetFields()
      if (this.$refs.myCkeditor) {
        this.$refs.myCkeditor.initEditor()
      }
    },

    inited(viewer) {
      this.$viewer = viewer
    },
    handlePreview() {
      for (let i in this.imgArr) {
        if (this.imgArr[i] == this.imgUrl) {
          this.$viewer.index = i
        }
      }
      this.$viewer.show()
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-uploader-form {
  display: flex;

  // flex-direction: column;
  .no-img {
    width: 100%;
    height: 100%;
    font-weight: 600;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/ .el-form-item__content {
    width: 100%;
    height: 100%;
    margin-left: 0 !important;
  }

  .avatar-uploader {
    border: 1px dashed #8c939d;
    height: 100%;

    &:hover {
      color: $primary;
      border-color: $primary;
    }

    .avatar {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    i {
      font-size: 28px !important;
      color: #8c939d;
    }

    /deep/.el-upload {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
}

/deep/.el-cascader {
  &.is-disabled {
    .el-input__suffix {
      display: none;
    }
  }
}

.swiper-container {
  width: 100%;

  .swiper-wrapper {
    flex: 1;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    // .pic-view {
    //   width: 100%;
    // }
  }

  /* 置灰按钮的样式 */
  .my-button-disabled {
    opacity: 0.5;
  }

  /*先去掉默认样式*/
  .swiper-button-prev:after {
    display: none;
  }

  .swiper-button-next:after {
    display: none;
  }

  /*再自定义样式*/
  .swiper-button-prev {
    width: 30px;
    height: 30px;
    background: url('~@assets/images/icon_left@2x.png') no-repeat;
    background-size: 100% 100%;
  }

  .swiper-button-next {
    width: 30px;
    height: 30px;
    background: url('~@assets/images/icon_right@2x.png') no-repeat;
    background-size: 100% 100%;
  }
}

.g-select-input {
  /deep/.input-item .el-input__inner {
    border-radius: 20px 0 0 20px;
  }

  /deep/ .select-item .el-input__inner {
    border-radius: 0 20px 20px 0;
  }
}

.dialog-add-choose-collect {
  &.view-dialog {
    /deep/.el-dialog {
      // .el-tabs__header {
      //   top: 85px;
      // }

      // .el-dialog__headerbtn {
      //   top: 96px;
      // }
    }
  }

  .tag {
    width: 100%;
    height: 56px;

    &.tag-top {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  /deep/.el-dialog {
    padding: 0;

    .el-dialog__header {
      padding: 38px 0px 16px 30px;
    }

    .el-dialog__body {
      .table-content {
        padding: 0 20px 20px;

        .bg-content {
          background: url(~@assets/images/bg_font@2x.png) no-repeat center;
          background-size: 100% 100%;
        }
      }
    }
  }

  /deep/.el-tabs {
    min-height: 630px;

    .el-tabs__header {
      position: absolute;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      margin-bottom: 0;
      height: 30px;
    }
  }

  /deep/.el-tabs__nav-wrap {
    &::after {
      display: none;
    }

    .el-tabs__nav-scroll {
      display: flex;
      justify-content: center;
    }
  }
}

/deep/.trans {
  min-height: 167px;
  max-height: 300px;
  overflow-y: auto;
  padding-right: 16px;

  img {
    width: 100%;
  }
}

.img-uploader {
  cursor: pointer;
  height: 100%;
  line-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.hd-wrapper {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  align-items: center;
  margin-top: 20px;

  .item {
    cursor: pointer;
    display: flex;
    align-items: baseline;
  }
}
</style>
